import { render } from "./DepItemsDaily.vue?vue&type=template&id=71f07a44&scoped=true"
import script from "./DepItemsDaily.vue?vue&type=script&lang=js"
export * from "./DepItemsDaily.vue?vue&type=script&lang=js"

import "./DepItemsDaily.vue?vue&type=style&index=0&id=71f07a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f07a44"]])

export default __exports__